export default __webpack_public_path__ + "static/media/logo-nuit.462bf2ba.png";